import * as React from 'react';
type Props = {
	label: string;
	onAccept: (...args: Array<any>) => any;
	selected: boolean;
};
export default ({label, onAccept, selected}: Props) => (
	<li className={`section-item ${selected ? 'focus' : ''}`} onMouseDown={onAccept}>
		{label}
	</li>
);
